// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5e28adff","453":"8464da48","455":"25b5ef40","977":"91715c53"}[chunkId] + ".chunk.js";
};